<div class="p-fluid" *ngIf="enable === true">
  <img
    class="img-fluid"
    src="../../assets/img/app-loader.gif"
    style="max-width: 800px"
  />
</div>
